import { useReducer, useEffect } from "react";
import axios from "axios";

const dataFetchReducer = (state, action) => {
  switch (action.type) {
    case "FETCH_INIT":
      return {
        ...state,
        isLoaded: false,
        isError: false,
      };
    case "FETCH_SUCCESS":
      return {
        ...state,
        isLoaded: true,
        isError: false,
        data: action.payload,
        pagination: action.pagination,
      };
    case "FETCH_FAILURE":
      return {
        ...state,
        isLoaded: false,
        isError: true,
      };
    default:
      throw new Error();
  }
};

const useApiData = (url) => {
  const [state, dispatch] = useReducer(dataFetchReducer, {
    isLoaded: false,
    isError: false,
    data: [],
    pagination: {},
  });

  useEffect(() => {
    let didCancel = false;

    const fetchData = async () => {
      dispatch({ type: "FETCH_INIT" });

      try {
        const result = await axios(url);

        if (!didCancel) {
          dispatch({
            type: "FETCH_SUCCESS",
            payload: result.data,
            pagination: {
              total: result.headers.hasOwnProperty("x-pagination-total-count")
                ? parseInt(result.headers["x-pagination-total-count"])
                : null,
              page: result.headers.hasOwnProperty("x-pagination-page-count")
                ? parseInt(result.headers["x-pagination-page-count"])
                : null,
            },
          });
        }
      } catch (error) {
        if (!didCancel) {
          dispatch({ type: "FETCH_FAILURE" });
        }
      }
    };

    fetchData();

    return () => {
      didCancel = true;
    };
  }, [url]);

  return { ...state };
};

export default useApiData;
